/** CoStar.Api.Analytics.CommonEntities.Enums.Property.PropertyType */
export var PropertyType;
(function (PropertyType) {
    PropertyType[PropertyType["Unknown"] = 0] = "Unknown";
    PropertyType[PropertyType["Hospitality"] = 1] = "Hospitality";
    PropertyType[PropertyType["Industrial"] = 2] = "Industrial";
    PropertyType[PropertyType["Land"] = 3] = "Land";
    PropertyType[PropertyType["Residential"] = 4] = "Residential";
    PropertyType[PropertyType["Office"] = 5] = "Office";
    PropertyType[PropertyType["Retail"] = 6] = "Retail";
    PropertyType[PropertyType["Flex"] = 7] = "Flex";
    PropertyType[PropertyType["SportsEntertainment"] = 8] = "SportsEntertainment";
    PropertyType[PropertyType["MixedUse"] = 9] = "MixedUse";
    PropertyType[PropertyType["Specialty"] = 10] = "Specialty";
    PropertyType[PropertyType["MultiFamily"] = 11] = "MultiFamily";
    PropertyType[PropertyType["ShoppingCenter"] = 12] = "ShoppingCenter";
    PropertyType[PropertyType["HealthCare"] = 13] = "HealthCare";
    PropertyType[PropertyType["MobileHome"] = 14] = "MobileHome";
    PropertyType[PropertyType["Student"] = 31] = "Student";
    PropertyType[PropertyType["All"] = -1] = "All";
})(PropertyType || (PropertyType = {}));
